













import { Vue, Component, Prop } from 'vue-property-decorator';
import Picture from '@/components/Picture/Picture.vue';
@Component({
  components: {
    Picture
  }
})
export default class BusinessDescription extends Vue {
  @Prop({ required: true }) name!: string;
  @Prop({ required: false }) city!: string;
  @Prop({ required: false }) managerName!: string;
  @Prop({ required: false }) imageSrc!: string;
}
